import React, { useMemo, useState } from 'react';
import * as Sentry from '@sentry/react';
import { GENERIC_PAYMENT_ERROR, PAYMENT_METHODS, PAYMENT_PROVIDER } from '../../constants';
import Check from '../check/check';
import ACHBankTransfer from '../ACHBankTransfer/ACHBankTransfer';
import StripeElement from '../../stripe/StripeElement';
import apiAccess from '../../../../api/apiAccess';
import { XpressBillPay } from '../../xpressbillpay';

export const PaymentForm = ({ paymentMethod, flow, provider, onSuccess, city, paymentID, signatoryName, userEmail, permitIdentifier, fees }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState();

  const getPaymentApi = (paymentMethod, provider) => {
    switch (paymentMethod) {
      case PAYMENT_METHODS.CHECK:
        return apiAccess.payByCheck;
      case PAYMENT_METHODS.CREDIT_OR_DEBIT__CARD:
        if (provider === PAYMENT_PROVIDER.STRIPE) {
          return apiAccess.payByCreditCard;
        }
        return apiAccess.payGeneric;
      case PAYMENT_METHODS.ACH_BANK_TRANSFER:
        return apiAccess.payByACHCredit;
      case PAYMENT_METHODS.ACH_DIRECT_DEBIT:
        if (provider === PAYMENT_PROVIDER.STRIPE) {
          return apiAccess.payByACHCredit;
        }
        return apiAccess.payGeneric;
      default:
        return undefined;
    }
  };

  const totalDue = useMemo(() => {
    switch (paymentMethod) {
      case PAYMENT_METHODS.CHECK:
        return fees.checkTotal
      case PAYMENT_METHODS.CREDIT_OR_DEBIT__CARD:
        return fees.ccTotal;
      case PAYMENT_METHODS.ACH_BANK_TRANSFER:
      case PAYMENT_METHODS.ACH_DIRECT_DEBIT:
      default:
        return fees.achTotal;
    }
  }, [fees, paymentMethod]);

  const handlePayment = async () => {
    setLoading(true);
    const paymentApi = getPaymentApi(paymentMethod, provider);
    try {
      const response = await paymentApi(paymentID, signatoryName, userEmail);
      onSuccess();
      return response;
    } catch (err) {
      setError(GENERIC_PAYMENT_ERROR);
      Sentry.captureException(err);
    } finally {
      setLoading(false);
    }
  };

  if (paymentMethod === PAYMENT_METHODS.CHECK) {
    return (
      <Check
        onPay={handlePayment}
        loading={loading}
        error={error}
      />
    );
  } else if (paymentMethod === PAYMENT_METHODS.ACH_BANK_TRANSFER) {
    return (
      <ACHBankTransfer
        onPay={handlePayment}
        loading={loading}
        error={error}
        city={city}
        clientPaymentInfo={{
          total_amount_due: '',
          bank_name: '',
          routing_number: '',
          account_number: '',
        }}
      />
    );
  } else if (provider === PAYMENT_PROVIDER.STRIPE) {
    return (
      <StripeElement
        flow={flow}
        onPay={handlePayment}
        paymentMethod={paymentMethod}
      />
    );
  } else if (provider === PAYMENT_PROVIDER.XPRESS_BILL_PAY) {
    return (
      <XpressBillPay
        flow={flow}
        onPay={handlePayment}
        permitIdentifier={permitIdentifier}
        totalDue={totalDue}
        loading={loading}
        error={error}
      />
    );
  }

  return <></>;
};
